module.exports = __webpack_public_path__ + "static/img/ic_linechart_blurred.b1857bf8.png";